<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
          <!-- <div class="filter-box">
              <span class="label">业务名称</span>
              <el-input
                  v-model="listQuery.name"
                  style="width: 200px"
                  :size="t('table.btnSize')"
                  class="filter-item"
                  clearable
                  @keyup.enter="handleFilter"
              />
          </div> -->
          <div class="filter-box">
              <el-button
                  v-waves
                  class="filter-item "
                  type="primary"
                  :size="t('table.btnSize')"
                  @click="handleFilter"
              >
                  {{ t("table.search") }}
              </el-button>
              <el-button
                v-permission="{ pkey: `${permissionName}_ADD` }"
                class="filter-item"
                type="primary"
                :size="t('table.btnSize')"
                @click="handleCommand('add')"
              >
                {{ t("table.add") }}
              </el-button>
              <el-button
                  v-waves
                  class="filter-item"
                  :size="t('table.btnSize')"
                  @click="handleReset"
              >
                  {{ t("table.reset") }}
              </el-button>
          </div>
      </div>
      <TableList
          v-loading="listLoading"
          :dataList="list"
          :total="total"
          :columnAllData="columnAllData"
          :page="listQuery.page"
          :size="listQuery.size"
          :tableName="TableName"
          :permissionName="permissionName"
          @command-change="handleCommand"
          :can-change-column="false"
          :can-refresh="false"
      >
          <template v-slot:operation-action="scope">
              <el-link
                v-permission="{ pkey: `${permissionName}_EDIT` }"
                href="javascript:void(0);"
                class="mr-10"
                type="primary"
                @click="handleCommand('edit', scope.row)"
              >
                {{ t("table.edit") }}
              </el-link>
              <el-link
                v-permission="{ pkey: `${permissionName}_DELETE` }"
                href="javascript:void(0);"
                type="danger"
                @click="handleCommand('delete', scope.row)"
              >
                {{ t("table.delete") }}
              </el-link>
          </template>
      </TableList>
    </div>
    <FormComponent
      v-if="dialogFormVisible"
      :id="activeId"
      :initFormData="initFormData"
      :fromFieldData="fromFieldData"
      :dialogFormVisible="dialogFormVisible"
      :api="pathApi"
      @update:visibel="() => dialogFormVisible = false"
      @submit="handleSubmit(formData)"
    />
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getDetailById, deleteById, getPageList } from '@/apis/Dictionary'

import { PaymentAccountModel } from '@/model/Index'

import FormComponent from '@/components/Form/index.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { TableField } from './FieldTable'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'Businessclassdic',
  components: {
    FormComponent,
    TableList
  },
  setup() {
    const { t } = useI18n()

    const dataMap = reactive({
      TableName: TableName.TABLE_BUSINESSCLASS,
      permissionName: permissionName.BUSINESSCLASS,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: FromFieldData,
      columnAllData: TableField,
      pathApi: 'businessClass',
      activeId: 0,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        page: 1,
        size: 10
      },
      dialogFormVisible: false,

      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
        }
      },
      getList() {
        dataMap.listLoading = true
        getPageList(dataMap.pathApi, dataMap.listQuery).then((res: any) => {
          dataMap.list = res.data || []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          page: 1,
          size: 20
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.fromFieldData = cloneDeep(dataMap.initFormData)

        getDetailById(dataMap.pathApi, row.id).then((res: any) => {
          dataMap.fromFieldData.forEach((k: any) => {
            if (k.type === 1) {
              k.formList.forEach((field: any) => {
                field.value = res[field.fieldKey]
              })
            }
          })
          dataMap.dialogFormVisible = true
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById(dataMap.pathApi, row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      }
    })
    onMounted(() => {
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
<style  lang="scss">

</style>
